<template>
  <v-content>
    <EditSubDetailsDialog ref="detailsDialog" />

    <OLoadingDialog :value="isLoading" />

    <div class="full-width">
      <v-toolbar class="card-bar">
        <v-toolbar-title>Subscriptions</v-toolbar-title>

        <v-btn icon @click="reload" class="ml-5">
          <v-icon>refresh</v-icon>
        </v-btn>
        <OSelectColsButton :fullSpec="fullSpec" v-model="vars" />

        <v-spacer />

        <!-- v-model.lazy não funciona em custom cpts -->
        <v-text-field
          :value="txtKeywords"
          @change="
            v => {
              txtKeywords = v
              nav.offset = 0
            }
          "
          label="Filtro por palavras-chave..."
          clearable
          @click:clear="
            txtKeywords = null
            nav.offset = 0
          "
          single-line
          hide-details
          class="pa-0"
        />

        <v-spacer />

        <!-- <v-switch
                v-model="includeInactive"
                label="Mostrar inativos"
                hide-details
                class="pa-0 ml-5"
              />
              <v-spacer /> -->

        <!-- <v-btn color="primary" @click="newRow">
                Nova Regra...
              </v-btn> -->
      </v-toolbar>

      <OPaginatedTable
        :spec="spec"
        :items="rows"
        :count="count"
        :navigation="nav"
        @update:navigation="v => (nav = v)"
        @rowClicked="selectRow"
      />
    </div>
  </v-content>
</template>

<script>
import { Subscription } from '@/models'
import { OPaginatedTable, OLoadingDialog } from 'oderon-vue'
import { fullSpec } from './subscription-columns'
import { getPref, savePref } from 'oderon-vue/Prefs'
import { selectCols } from 'oderon-commons/src/tables'

import EditSubDetailsDialog from './EditSubDetailsDialog.vue'
import OSelectColsButton from 'oderon-vue/cpts/OSelectColsButton.vue'

const _key = 'oderonSubscriptionCols'

export default {
  components: {
    OLoadingDialog,
    OPaginatedTable,
    EditSubDetailsDialog,
    OSelectColsButton
  },
  data() {
    return {
      isLoading: false,
      txtKeywords: null,
      includeInactive: false,

      rows: [],
      count: 0,
      nav: {
        limit: 10,
        offset: 0
      },

      fullSpec,
      vars: getPref(_key, fullSpec.defCodes)
    }
  },
  computed: {
    spec() {
      return selectCols(this.fullSpec, this.vars)
    },
    apiParams() {
      return {
        limit: this.nav.limit,
        offset: this.nav.offset,
        keywords: this.txtKeywords
      }
    }
  },
  mounted() {
    this.reload()
  },
  watch: {
    vars() {
      savePref(_key, this.vars)
    },
    apiParams() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$loading(this.fetchData())
    },

    async fetchData() {
      let data = await Subscription.findAll(this.apiParams)
      this.rows = data.rows
      this.count = data.count
    },

    // go(row, idx, evt) {
    //   if (evt && (evt.ctrlKey || evt.button == 1)) {
    //     window.open(`/#/customers/${row.id}`, '_blank')
    //   } else {
    //     this.$router.push(`/customers/${row.id}`)
    //   }
    // }
    async selectRow(row) {
      let dialog = this.$refs.detailsDialog
      let res = await dialog.open(row.id)
      if (res === 'DELETE') {
        await this.confirmDelete(row)
      } else if (res != null) {
        await this.$loading(async () => {
          await Subscription.save(res)
          await this.fetchData()
        })

        this.$snack('Salvo com sucesso')
      }
    },

    async confirmDelete(sub) {
      let result = await this.$confirm({
        message: `Deseja remover a regra ${sub.name}?`,
        okText: 'Sim, remover',
        cancelText: 'Não, cancelar'
      })

      if (result) {
        await this.$loading(async () => {
          await Subscription.delete(sub.id)
          await this.fetchData()
        })

        this.$snack('Removida com sucesso')
      }
    }
  }
}
</script>

<style></style>
